import { takeLatest } from 'redux-saga/effects';

import { LOG_OUT, SIGN_IN_SUCCESS, SIGN_UP_SUCCESS } from '../../../actions/auth';

import onSignIn from './onSignIn';
import onLogOut from './onLogOut';
import onSingUp from './onSignUp';

export default function* fn() {
  yield takeLatest(SIGN_IN_SUCCESS.type, onSignIn);
  yield takeLatest(LOG_OUT.type, onLogOut);
  yield takeLatest(SIGN_UP_SUCCESS.type, onSingUp);
}
